// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"00d51c6f","977":"703f5305"}[chunkId] + ".chunk.js";
};